import React from 'react';

const CompaniesForm = ({ formData, setFormData }) => {
  return (
    <>
      <input
        type="text"
        placeholder="Company Name"
        value={formData.name || ''}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        required
      />
      <input
        type="text"
        placeholder="Industry"
        value={formData.industry || ''}
        onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        required
      />
      <select
        value={formData.employees || '50-100'}
        onChange={(e) => setFormData({ ...formData, employees: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      >
        <option value="1-50">1-50</option>
        <option value="50-100">50-100</option>
        <option value="100-500">100-500</option>
        <option value="500+">500+</option>
      </select>
      <select
        value={formData.partnership || 'Bronze'}
        onChange={(e) => setFormData({ ...formData, partnership: e.target.value })}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      >
        <option value="Bronze">Bronze</option>
        <option value="Silver">Silver</option>
        <option value="Gold">Gold</option>
      </select>
    </>
  );
};

export default CompaniesForm;
